import { select } from "../../utils";
import gsap from "gsap";

class AppLoader {
  domElement: HTMLElement | null;
  percentage: HTMLElement | null;
  progressBar: HTMLProgressElement | null;
  animation: gsap.core.Tween | gsap.core.Timeline;

  constructor() {
    this.domElement = select(".loader__wrapper");
    this.percentage = select(".loader__percentage");
    this.progressBar = select(
      "progress.loader__progress",
    ) as HTMLProgressElement | null;

    if (!this.progressBar) {
      this.animation = gsap.timeline({ paused: true });
      return;
    }

    this.animation = gsap.to(this.progressBar, {
      ease: "power1.inOut",
      duration: 10,
      paused: true,
      value: 100,
      onUpdate: () => {
        if (!this.percentage || !this.progressBar) return;
        this.percentage.textContent = `${Math.round(this.progressBar.value)}%`;
      },
    });
  }

  start() {
    this.animation.play();
  }

  end() {
    if (this.animation.isActive()) {
      this.animation.duration(1);
    }
  }

  hide() {
    if (!this.domElement) return;
    this.domElement.style.display = "none";
  }
}

export { AppLoader };
